module.exports = __webpack_public_path__ + "static/g-8-38f572fd3ae805e6f73dd0d4cd19bae5.jpg";